import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgLuggage = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    stroke="#17181A"
    {...props}
  >
    <path d="M4.5 20.5v-14a2 2 0 0 1 2-2h11a2 2 0 0 1 2 2v14M7 21.5h10M9 3.726V1h6v2.626" />
    <path
      clipRule="evenodd"
      d="M5.5 23a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Zm13 0a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z"
    />
  </svg>
);
const Memo = memo(SvgLuggage);
export default Memo;
